<template>
  <!-- 投保信息  -->
  <Form ref="form" :label-width="130" class="page-form detail" v-if="detailData">
    <div class="form-title">基本信息</div>
    <FormItem label="订单号">
      <span>{{detailData.insureUniqueId}}</span>
    </FormItem>
    <FormItem label="承保时间">
      <span>{{detailData.createTime&&detailData.createTime.substring(0,16)}}</span>
    </FormItem>
    <FormItem label="保单号">
      <span>{{detailData.policyNo}}</span>
    </FormItem>
    <FormItem label="产品名称">
      <span>{{detailData.productName}}</span>
    </FormItem>
    <FormItem label="归属业务员">
      <span>{{detailData.salesmanName}}</span>
    </FormItem>
    <FormItem label="所属团队">
      <span>{{detailData.groupName}}</span>
    </FormItem>
    <FormItem label="所属机构">
      <span>{{detailData.orgName}}</span>
    </FormItem>
    <FormItem label="保障期限">
      <span v-if="detailData.guaranteeType==1">保终身</span>
      <span v-if="detailData.guaranteeType==2">保{{detailData.guaranteeLimit}}岁</span>
      <span v-if="detailData.guaranteeType==3">保{{detailData.guaranteeLimit}}年</span>
      <span v-if="detailData.guaranteeType==4">保{{detailData.guaranteeLimit}}个月</span>
      <span v-if="detailData.guaranteeType==5">保{{detailData.guaranteeLimit}}天</span>
    </FormItem>
    <FormItem label="起保日期">
      <span>{{detailData.startTime}}</span>
    </FormItem>
    <FormItem label="终保日期">
      <span>{{detailData.endTime}}</span>
    </FormItem>
    <FormItem label="回执回销状态">
      <lzDicTxt dicType="RECEIPT_STATUS" :dicCode="detailData.receiptStatus" v-if="detailData.receiptStatus"></lzDicTxt>
    </FormItem>
    <FormItem label="回执回销日期">
      <div>{{detailData.receiptDate|filterTime('YYYY-MM-DD')}}</div>
    </FormItem>
    <FormItem label="回执签收日期">
      <div>{{detailData.receiptDate2|filterTime('YYYY-MM-DD')}}</div>
    </FormItem>
    <FormItem label="回访状态">
      <lzDicTxt dicType="VERIFY_STATUS" :dicCode="detailData.revisitStatus" v-if="detailData.revisitStatus"></lzDicTxt>
    </FormItem>
    <FormItem label="回访日期">
      <div>{{detailData.revisitDate|filterTime('YYYY-MM-DD')}}</div>
    </FormItem>
    <FormItem label="犹豫期截止日">
      <span>{{detailData.hesitateDate&&detailData.hesitateDate.substring(0,10)}}</span>
    </FormItem>
    <FormItem label="总保费">
      <span>{{detailData.fee}}元</span>
    </FormItem>
    <FormItem label="交费方式">
      <span>{{detailData.payTypeDesc}}</span>
    </FormItem>
    <FormItem label="交费期">
      <span>{{detailData.paymentDesc}}</span>
    </FormItem>
    <FormItem label="状态">
      <span>{{detailData.policyStatus|filterInsureOrderStatus}}</span>
    </FormItem>
    <div class="form-title">投保人信息</div>
    <FormItem label="姓名">
      <span>{{holderData.name}}</span>
    </FormItem>
    <FormItem label="性别">
      <span>{{holderData.sex|filterSex}}</span>
    </FormItem>
    <FormItem label="证件类型">
      <span>{{holderData.cardType|filterCardType}}</span>
    </FormItem>
    <FormItem label="证件号">
      <span class="value" v-if="!holderData.eyeShow1">{{holderData.cardNumber}}</span>
      <span class="value" v-else>{{holderData.cardNumber1}}</span>
      <span v-if="holderData.cardNumber">
        <i class="iconfont iconxianshi eye-icon" v-if="holderData.eyeShow1" @click="openEye(holderData,'eyeShow1','cardNumber')"></i>
        <i class="iconfont iconyincang eye-icon" v-else @click="openEye(holderData,'eyeShow1','cardNumber')"></i>
      </span>
    </FormItem>
    <FormItem label="手机号码">
      <span class="value" v-if="!holderData.eyeShow2">{{holderData.mobile}}</span>
      <span class="value" v-else>{{holderData.mobile1}}</span>
      <span v-if="holderData.mobile">
        <i class="iconfont iconxianshi eye-icon" v-if="holderData.eyeShow2" @click="openEye(holderData,'eyeShow2','mobile')"></i>
        <i class="iconfont iconyincang eye-icon" v-else @click="openEye(holderData,'eyeShow2','mobile')"></i>
      </span>
    </FormItem>
    <FormItem label="电子邮箱">
      <span class="value" v-if="!holderData.eyeShow3">{{holderData.email}}</span>
      <span class="value" v-else>{{holderData.email1}}</span>
      <span v-if="holderData.email">
        <i class="iconfont iconxianshi eye-icon" v-if="holderData.eyeShow3" @click="openEye(holderData,'eyeShow3','email')"></i>
        <i class="iconfont iconyincang eye-icon" v-else @click="openEye(holderData,'eyeShow3','email')"></i>
      </span>
    </FormItem>
    <FormItem label="所在地区">
      <span>{{holderData.area}}</span>
    </FormItem>
    <FormItem label="详细地址">
      <span class="value" v-if="!holderData.eyeShow4">{{holderData.address}}</span>
      <span class="value" v-else>{{holderData.address1}}</span>
      <span v-if="holderData.address">
        <i class="iconfont iconxianshi eye-icon" v-if="holderData.eyeShow3" @click="openEye(holderData,'eyeShow4','address')"></i>
        <i class="iconfont iconyincang eye-icon" v-else @click="openEye(holderData,'eyeShow4','address')"></i>
      </span>
    </FormItem>
    <div class="form-title">账户信息</div>
      <FormItem label="银行卡户名" prop="bankCardName">
        <div>{{ detailData.bankCardName }}</div>
      </FormItem>
      <FormItem label="银行账户" prop="cardNo">
        <div>
          <span v-if="!detailData.eyeShow">{{ detailData.cardNo }}</span>
          <span v-else>{{ detailData.cardNo1 }}</span>
          <span v-if="detailData.cardNo">
            <i class="iconfont iconxianshi eye-icon" v-if="detailData.eyeShow" @click="openEye(detailData, 'eyeShow', 'cardNo')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye(detailData, 'eyeShow', 'cardNo')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem label="开户行" prop="bank">
        <div>{{ detailData.bank }}</div>
      </FormItem>
  </Form>
</template>

<script>
import lzDicTxt from "@/components/commons/lzDicTxt";
import filter from '@/api/filter'
import {common} from "@/api/mixins";
export default {
  components: {lzDicTxt},
  props: ["detailData"],
  mixins:[common],
  data() {
    return {
    };
  },
  computed: {
    holderData(){
      if(this.detailData && this.detailData.holder){
        return this.detailData.holder
      }
      return {}
    }
  },
  created() {},
  methods: {
    openEye(item,keyName,name){
      let operationType
      if(name == 'mobile'){
        operationType=2
      }else if(name =='cardNumber'){
        operationType=1
      }else if(name == 'address'){
        operationType = 5
      }else if(name == 'email'){
        operationType = 4
      } else if (name == 'cardNo') {
        operationType = 3;
      }
      if(!item[keyName]){
        this.descrypt({
          query:this.detailData.insureUniqueId,
          operationFunction:15,
          operationType:operationType,
          otherInfo:{
          type:1
        }
        },item,name+'1','order_30_10').then(()=>{
          this.$set(item, keyName, true);
        })
      }else{
        this.$set(item, keyName, false);
      }
    },
  },
  filters:{
    filterPayType:filter.filterPayType,
    filterInsureOrderStatus:filter.filterInsureOrderStatus,
    filterSex:filter.filterSex,
    filterCardType:filter.filterCardType,
  }

};
</script>
<style lang="scss" scoped>

</style>
